import hatsApi from '@/services/hatsApi'

export default {
  getPriceTypes (params) {
    let filter = params || ''
    return hatsApi().get('/system/price-type/?filter=' + filter)
  },
  getBasePrices (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/base-price?filter=' + JSON.stringify(filter))
  },
  getPriceRules (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/price-rule?filter=' + JSON.stringify(filter))
  },
  getPriceRule (id) {
    return hatsApi().get('/master-data/price-rule/' + id)
  },
  getPriceRuleCalcTypes (params) {
    let filter = params || ''
    return hatsApi().get('/system/price-rule-calc-type/?filter=' + JSON.stringify(filter))
  },
  getPriceRuleTypes (params) {
    let filter = params || ''
    return hatsApi().get('/system/price-rule-type/?filter=' + JSON.stringify(filter))
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Price.js